<template>
  <div class="SV publicLess">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text=""
      @load="onLoad"
      class="van-load"
    >
      <div class="null-box" v-if="isEmpty">
        <van-empty
          class="custom-image"
          image-size="100px"
          :image="require('../../../../assets/not.png')"
          description="未检出"
        />
      </div>

      <div v-else>
        <div
          class="sv-list publicLess-list"
          v-for="(item, index) in list"
          :key="index"
        >
          <h1 @click="wdClick(item)">{{ item.gene1 }}-{{ item.gene2 }}</h1>
          <div class="show-box"></div>
          <div class="data-box">
            <div class="border-data-box">
              <h1 @click="geneClick(item, item.gene1)">{{ item.gene1 }}</h1>
              <div class="flex-text">
                <div>
                  <p>染色体</p>
                  <h2>{{ item.chromosome1 }}</h2>
                </div>
                <div>
                  <p>断点位置</p>
                  <h2>{{ item.breakpointPosition1 }}</h2>
                </div>
              </div>
            </div>
            <div class="border-data-box">
              <h1 @click="geneClick(item, item.gene2)">{{ item.gene2 }}</h1>
              <div class="flex-text">
                <div>
                  <p>染色体</p>
                  <h2>{{ item.chromosome2 }}</h2>
                </div>
                <div>
                  <p>断点位置</p>
                  <h2>{{ item.breakpointPosition2 }}</h2>
                </div>
              </div>
            </div>
            <div class="border-data-box">
              <div class="flex-text">
                <div>
                  <p>突变频率</p>
                  <h2>{{ item.mutationFrequency }}</h2>
                </div>
                <div>
                  <p>外显子</p>
                  <h2>{{ item.exon }}</h2>
                </div>
              </div>
              <div class="flex-text" v-if="$route.query.userAgent != 'wxWeb'">
                <div>
                  <p>相同变异患者</p>
                  <h3 @click="byClick(item)">{{ item.cohort }}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { svData } from "@/api/reportQuery";
import { Toast } from "vant";
import { handleSearch } from "@/utils/search";
import { mapState } from "vuex";
import isiOS from "@/utils/iosAn";

export default {
  name: "SV",
  props: {
    searchVal: {
      type: String,
    },
  },
  data() {
    return {
      isEmpty: false,
      loading: false,
      finished: false,
      mutationData: [],
      list: [],
      searchData: [],
      badge: "",
    };
  },
  mounted() {
    this.getSv();
  },
  watch: {
    searchVal: function (val) {
      if (!val) {
        this.clearSearch();
      }
    },
  },
  computed: {
    ...mapState("embry", ["publicParams"]),
  },
  methods: {
    byClick(item) {
      let wdName = item.gene1 + "-" + item.gene2;
      let param = {
        name: "wdJiedu",
        type: "1",
        gene: wdName,
        proteinChange: "",
        tabIndex: "1",
        Jump: "1",
        fromSource: "sv",
        cancerTwo: item.cancerTwo,
        productCode: item.productCode,
      };
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    geneClick(item, geneName) {
      var num = "0";
      let param = {
        name: "wdJiedu",
        type: num,
        wdName: geneName,
        gene: geneName,
        proteinChange: "",
        tabIndex: "2",
        fromSource: "sv",
        webId: "BGXQ-TXBBYJG",
        cancerTwo: item.cancerTwo,
        productCode: item.productCode,
      };
      if (this.$route.query.userAgent == "wxWeb") {
        wx.miniProgram.navigateTo({
          url: "/packageWebView/pages/gene-jiedu/gene-jiedu?gene=" + geneName,
        });
      } else if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    wdClick(item) {
      var num = "1";
      let wdName = item.gene1 + "-" + item.gene2;
      let param = {
        name: "wdJiedu",
        type: num,
        gene: wdName,
        proteinChange: "",
        tabIndex: "2",
        fromSource: "sv",
        webId: "BGXQ-TXBBYJG",
        cancerTwo: item.cancerTwo,
        productCode: item.productCode,
      };
      if (this.$route.query.userAgent == "wxWeb") {
        wx.miniProgram.navigateTo({
          url: "/packageWebView/pages/site-jiedu/site-jiedu?site=" + wdName,
        });
      } else if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },

    clearSearch() {
      this.list = this.searchData;
      this.finished = false;
      this.isEmpty = false;
    },
    searchFn() {
      /**搜索查询的方法 */
      if (this.searchVal) {
        this.finished = true;

        this.list = handleSearch(this.searchVal, this.mutationData);
        if (this.searchVal != "" && this.list.length === 0) {
          this.isEmpty = true;
        }
      }
    },
    /**获取基因重排数据 */
    getSv() {
      this.loading = true;
      this.$nextTick(async () => {
        try {
          let { data } = await svData({
            labOriginalSampleNo: this.publicParams.labOriginalSampleNo,
            productId: this.publicParams.productId,
          });
          this.mutationData = data;
          this.list = this.mutationData;
          this.searchData = this.mutationData;
          if (data == "") {
            this.isEmpty = true;
          } else {
            this.isEmpty = false;
          }
          // this.badge = data.length;
          // if (this.badge > 100) {
          //   this.badge = 99 + "+";
          // }
          // this.$emit("badge-sv", this.badge);
          this.loading = false;
        } catch (error) {
          console.log(error);
        }
      });
    },
    onLoad() {
      this.loading = false;

      // 异步更新数据
      // if (this.mutationData.length == 0) {
      //   this.finished = true;
      // } else {
      //   if (this.list.length < 10) {
      //     this.list = this.mutationData;
      //     this.searchData = this.mutationData;
      //   } else {
      //     for (let i = 0; i < 10; i++) {
      //       this.list.push(this.mutationData[i]);
      //       this.searchData.push(this.mutationData[i]);
      //     }
      //   }

      //   // console.log(this.list)
      //   // 加载状态结束
      //   this.loading = false;
      //   // 数据全部加载完成
      //   if (this.list.length >= this.mutationData.length) {
      //     this.finished = true;
      //   }
      // }
    },
  },
};
</script>
<style lang="less" scoped>
@import "./styles/index.less";
.SV {
  .sv-list {
    .data-box {
      flex-direction: column;
      padding-right: 24px;
    }
    .border-data-box {
      border-bottom: 1px solid #e3e5e8;
      margin-bottom: 20px;
      &:last-child {
        border: 0;
      }
      h1 {
        height: 22px;
        line-height: 22px;
        margin-bottom: 12px;
      }
      .flex-text {
        display: flex;
        margin-bottom: 20px;
        & > div {
          flex: 1;
        }
      }
    }
  }
}
</style>
